/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * User type classification
 * @export
 */
export const PersonType = {
    Customer: 'customer',
    Guest: 'guest'
} as const;
export type PersonType = typeof PersonType[keyof typeof PersonType];


export function instanceOfPersonType(value: any): boolean {
    for (const key in PersonType) {
        if (Object.prototype.hasOwnProperty.call(PersonType, key)) {
            if (PersonType[key as keyof typeof PersonType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PersonTypeFromJSON(json: any): PersonType {
    return PersonTypeFromJSONTyped(json, false);
}

export function PersonTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonType {
    return json as PersonType;
}

export function PersonTypeToJSON(value?: PersonType | null): any {
    return value as any;
}

export function PersonTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PersonType {
    return value as PersonType;
}

